/**
 * Outcome of a single invoice processed inside a `DunningRun` run.
 *
 * - `PENDING` — created with the run, not yet processed.
 * - `SUCCESS` — a `DunningLetter` was issued; `dunningLetterId` is set.
 * - `SKIPPED` — re-validation at processing time disqualified the invoice;
 *   `skipReason` is set to one of the `SkipReason` enum values.
 * - `FAILED` — an exception escaped during processing; `errorMessage` is set.
 *   FAILED items do NOT promote the parent DunningRun to FAILED.
 */
export var DunningRunItemStatus;
(function (DunningRunItemStatus) {
    DunningRunItemStatus["PENDING"] = "pending";
    DunningRunItemStatus["SUCCESS"] = "success";
    DunningRunItemStatus["SKIPPED"] = "skipped";
    DunningRunItemStatus["FAILED"] = "failed";
})(DunningRunItemStatus || (DunningRunItemStatus = {}));
//# sourceMappingURL=dunning-run-item-status.enum.js.map